import {ReactNode} from 'react';

import {VehicleSeriesDefinitionContextType} from '../types';
import {VehicleSeriesDefinitionFormContext} from './VehicleSeriesDefinitionFormContext';

interface VehicleSeriesDefinitionContextProviderProps extends VehicleSeriesDefinitionContextType {
  children?: ReactNode;
}

export const VehicleSeriesDefinitionContextProvider = ({
  children,
  ...rest
}: VehicleSeriesDefinitionContextProviderProps) => (
  <VehicleSeriesDefinitionFormContext.Provider value={rest}>
    {children}
  </VehicleSeriesDefinitionFormContext.Provider>
);
